import { useState } from 'react';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import ProjectEditService from '../service/ProjectEditService';

const config = data => {
	return {
		key: 'projectEditForm',
		text: 'Project',
		textKey: 'project',
		service: ProjectEditService,
		fields: [
			{
				key: 'name',
				text: 'Name',
				textKey: 'name',
				component: EditFormTextField,
				required: true
			}
		]
	};
};

function ProjectEditForm() {
	const myConfig = config();
	return <EditFormPage config={myConfig} />;
}

export default ProjectEditForm;
